import React, { useEffect } from "react";
import ReactDOM from "react-dom";

export default function AlertDialog({ open, alertOption, message, title }) {
  useEffect(() => {
    if (!open) return;
    const handleKey = (e) => {
      if (e.key === "Escape") alertOption(false);
    };
    document.addEventListener("keydown", handleKey);
    return () => document.removeEventListener("keydown", handleKey);
  }, [open, alertOption]);

  if (!open) return null;

  return ReactDOM.createPortal(
    <div
      onClick={() => alertOption(false)}
      style={{
        position: "fixed",
        inset: 0,
        backgroundColor: "rgba(0, 0, 0, 0.35)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 10000,
        backdropFilter: "blur(3px)",
        WebkitBackdropFilter: "blur(3px)",
        fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          backgroundColor: "#fff",
          borderRadius: 16,
          boxShadow:
            "0 20px 60px rgba(0, 0, 0, 0.15), 0 4px 16px rgba(0, 0, 0, 0.08)",
          width: 400,
          maxWidth: "calc(100vw - 32px)",
          overflow: "hidden",
          animation: "dialog-in 0.15s ease",
        }}
      >
        {/* Body */}
        <div style={{ padding: "28px 28px 20px" }}>
          <h3
            style={{
              margin: "0 0 8px",
              fontSize: 17,
              fontWeight: 600,
              color: "#111827",
              lineHeight: 1.3,
            }}
          >
            {title || "Confirm deletion"}
          </h3>

          <p
            style={{
              margin: 0,
              fontSize: 14,
              color: "#6b7280",
              lineHeight: 1.6,
            }}
          >
            {message ||
              "Are you sure you want to delete this? This action cannot be undone."}
          </p>
        </div>

        {/* Footer */}
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: 10,
            padding: "14px 28px",
            borderTop: "1px solid #f3f4f6",
            backgroundColor: "#fafafa",
          }}
        >
          <button
            onClick={() => alertOption(false)}
            style={{
              height: 38,
              padding: "0 16px",
              border: "1px solid #e5e7eb",
              borderRadius: 8,
              background: "#fff",
              color: "#374151",
              fontSize: 14,
              fontWeight: 500,
              fontFamily: "inherit",
              cursor: "pointer",
              outline: "none",
              transition: "background 0.15s",
            }}
            onMouseEnter={(e) => (e.currentTarget.style.background = "#f9fafb")}
            onMouseLeave={(e) => (e.currentTarget.style.background = "#fff")}
          >
            Cancel
          </button>
          <button
            autoFocus
            onClick={() => alertOption(true)}
            style={{
              height: 38,
              padding: "0 16px",
              border: "none",
              borderRadius: 8,
              background: "#ef4444",
              color: "#fff",
              fontSize: 14,
              fontWeight: 600,
              fontFamily: "inherit",
              cursor: "pointer",
              outline: "none",
              transition: "background 0.15s",
            }}
            onMouseEnter={(e) => (e.currentTarget.style.background = "#dc2626")}
            onMouseLeave={(e) => (e.currentTarget.style.background = "#ef4444")}
          >
            Delete
          </button>
        </div>
      </div>

      <style>{`
        @keyframes dialog-in {
          from { opacity: 0; transform: scale(0.96) translateY(6px); }
          to   { opacity: 1; transform: scale(1)    translateY(0); }
        }
      `}</style>
    </div>,
    document.body
  );
}
